export default __webpack_public_path__ + "static/ui-kit-26e4a0c7d219ffa91064cd071f6bff81.png";